import React from "react";
import { IconX } from "@tabler/icons-react";
import TransunionSmall from "_assets/logos/transunion_small.svg";
import "./Header.scss";

function Header(props) {
  const { report, view } = props;
  const primaryName = report?.indicative?.names?.[0]?.person;
  const pdfUrl = report?.pdfUrl;
  return (
    <div className="header">
      <img src={TransunionSmall} alt="TransUnion" />
      <div className="report-details">
        <h2>
          {view === "applicant" ? "Primary Applicant" : "Co-Applicant"} Credit
          Report
        </h2>
        <p>
          {primaryName?.last}, {primaryName?.first} {primaryName?.middle || ""}
          {pdfUrl ? (
            <span>
              {" "}
              -{" "}
              <a
                className="doc-download"
                href={pdfUrl}
                target="_blank"
                rel="noreferrer"
              >
                Download Report
              </a>
            </span>
          ) : (
            ""
          )}
        </p>
      </div>
      <div className="close-drawer" onClick={props.close}>
        <IconX />
      </div>
    </div>
  );
}

export default Header;
